import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { THEME_LOOKUP_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const ThemeLookupService = ComposedComponent =>
  reduxFetch([
    {
      resource: THEME_LOOKUP_RESOURCE,
      method: 'get',
      request: (id, rejectCallback, t) => ({
        url: apiRoutes.themeLookups(id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getThemeLookupFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default ThemeLookupService;
